import { Dropdown, DropdownItem } from '@frontend/components/common';
import React from 'react';
import { IconType } from 'react-icons';
import { LuChevronDown } from 'react-icons/lu';

import { ModalItemDropdownOption } from '../modal-item/modal-item';

interface ModalTabNavProps {
    modalTabItems: {
        order?: number;
        label?: React.ReactNode;
        icon?: IconType;
        identifier: string;
        main?: boolean;
        dropdownOptions?: ModalItemDropdownOption[];
    }[];
    onChange: (key: string) => void;
    activeSubsection?: string;
    activeDropdownOption?: string;
    onDropdownChange?: (tabIdentifier: string, optionIdentifier: string) => void;
}

export const ModalTabNav = (props: ModalTabNavProps) => {
    return (
        <ul className='inline-flex items-center justify-start gap-4'>
            {props.modalTabItems.map((key) => {
                const selectedTab = props.activeSubsection === key.identifier.toLowerCase();

                // If this tab has dropdown options, render as dropdown
                if (key.dropdownOptions && key.dropdownOptions.length > 0) {
                    return (
                        <li
                            key={key.identifier}
                            className={`border-b-2 px-1 py-2 text-base font-medium ${selectedTab ? 'text-brand-primary border-brand-primary' : 'text-foreground-default hover:border-foreground-default border-transparent hover:border-b-2'} flex items-center justify-start gap-2`}>
                            <Dropdown
                                label={
                                    <span className='flex items-center gap-1 text-base font-medium'>
                                        {key.label ?? key.identifier}
                                        <LuChevronDown className='size-4' />
                                    </span>
                                }
                                buttonStyle='bg-transparent border-none p-0 hover:cursor-pointer text-inherit font-inherit'
                                hideChevron>
                                {key.dropdownOptions.map((option) => (
                                    <DropdownItem
                                        key={option.identifier}
                                        label={option.label}
                                        onMouseDown={(event) => {
                                            // Portaled menu sits outside the pane; stop mousedown
                                            // so ModalProvider does not treat it as backdrop dismiss.
                                            event.stopPropagation();
                                        }}
                                        onClick={() => {
                                            // Only onDropdownChange — onChange alone would clear the URL dropdown
                                            // and fire a second navigate on the same click.
                                            if (props.onDropdownChange) {
                                                props.onDropdownChange(key.identifier, option.identifier);
                                            } else {
                                                props.onChange(key.identifier);
                                            }
                                        }}
                                    />
                                ))}
                            </Dropdown>
                        </li>
                    );
                }

                // Regular tab (existing behavior)
                return (
                    <li
                        key={key.identifier}
                        onClick={() => props.onChange(key.identifier)}
                        data-testid={`nav-item${key.identifier}`}
                        className={`border-b-2 px-1 py-2 text-base font-medium ${selectedTab ? 'text-brand-primary border-brand-primary' : 'text-foreground-default hover:border-foreground-default border-transparent hover:border-b-2'} flex items-center justify-start gap-2 hover:cursor-pointer`}>
                        <a
                            data-tab-target={key.identifier}
                            role='tab'
                            aria-selected={selectedTab}>
                            {key.label ?? key.identifier}
                        </a>
                    </li>
                );
            })}
        </ul>
    );
};
